import React from 'react';
import ReactDOM from "react-dom/client";
import PricingBlockWrapper from "./components/pricingBlockWrapper";
import GettingStartedApp from "./components/gettingStartedApp";
import FlightTimeWrapper from "./components/flight-time-wrapper";

const appDom = document.getElementById('root');
if (appDom) {
  const domRoot = ReactDOM.createRoot(appDom);
  const link = appDom.getAttribute('data-link');
  const id = appDom.getAttribute('data-id');
  const lang = appDom.getAttribute('data-lang');
  domRoot.render(<GettingStartedApp
    lang={lang}
    link={link}
    widgetKey={`gsa-${id}`}
  />);
}

let hash = window.location.hash ? window.location.hash : null;

if(hash){
    const hashSelector = document.querySelector(hash);
    
    if(hashSelector && hashSelector.localName === 'li'){
        hashSelector.classList.add('is-active');
    }
}

window.addEventListener('hashchange',function(){
    hash = window.location.hash ? window.location.hash : null;

    if(hash){
        const hashSelector = document.querySelector(hash);
        
        if(hashSelector && hashSelector.localName === 'li'){
            const active = hashSelector.parentNode.querySelector('.is-active');
           
            if(active){
                active.classList.remove('is-active');
                active.firstElementChild.setAttribute('aria-expanded',false);
                active.lastElementChild.setAttribute('aria-hidden',true);
                active.lastElementChild.style.display = 'none';
            }

            hashSelector.scrollIntoView();
            hashSelector.classList.add('is-active');
            hashSelector.firstElementChild.setAttribute('aria-expanded',true);
            hashSelector.lastElementChild.setAttribute('aria-hidden',false);
            hashSelector.lastElementChild.style.display = 'block';
        }
    }
})

const pricingBlocks = document.querySelectorAll('[data-pricing-block]');
for (const pricingBlock of pricingBlocks) {
    const domRoot = ReactDOM.createRoot(pricingBlock);
    const pricingBlockLink = pricingBlock.getAttribute('data-pricing-block');
    const id = pricingBlock.getAttribute('data-id');
    const plane = pricingBlock.getAttribute('data-plane');
    const ownership = pricingBlock.getAttribute('data-ownership');
    const lang = pricingBlock.getAttribute('data-lang');
    const disableFlightCalculator = pricingBlock.getAttribute('data-disable-calculator');

    domRoot.render(<PricingBlockWrapper
        widgetKey={`pb-${id}`}
        link={pricingBlockLink}
        id={id}
        defaultPlane={parseInt(plane)}
        defaultOwnership={parseInt(ownership)}
        disableFlightCalculator={disableFlightCalculator && parseInt(disableFlightCalculator) === 1}
        lang={lang}
    />);
}


const ftBlocks = document.querySelectorAll('[data-flight-block]');
for (const ftBlock of ftBlocks) {
    const domRoot = ReactDOM.createRoot(ftBlock);
    const id = ftBlock.getAttribute('data-id');
    const lang = ftBlock.getAttribute('data-lang');
    domRoot.render(<FlightTimeWrapper
        widgetKey={`fb-${id}`}
        id={id}
        lang={lang}
    />);
}

